import { render, staticRenderFns } from "./SharedObjectCard.vue?vue&type=template&id=2ef1c377&scoped=true&"
import script from "./SharedObjectCard.vue?vue&type=script&lang=ts&"
export * from "./SharedObjectCard.vue?vue&type=script&lang=ts&"
import style0 from "./SharedObjectCard.vue?vue&type=style&index=0&id=2ef1c377&scoped=true&lang=scss&"
import style1 from "./SharedObjectCard.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef1c377",
  null
  
)

export default component.exports